export const config = {
  rowSelection: false,
  columns: [
    {
      title: '活动名称',
      dataIndex: 'activityName',
      width: 120,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '活动类型',
      dataIndex: 'activityProductTypeName',
      width: 120,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: "产品SKU_ID",
      width: 150,
      dataIndex: "skuId",
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: "产品名称（SKU）",
      dataIndex: "skuName",
      width: 150,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: "销售价",
      width: 80,
      dataIndex: "salePrice",
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: "产品类型",
      dataIndex: "prodTypeName",
      width: 100,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: "优惠类型",
      dataIndex: "promoTypeName",
      width: 120,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: "状态",
      dataIndex: "enabled",
      width: 120,
      ellipsis: {
        showTitle: false,
      },
      render: 'statusRender',
    },
    {
      title: "优惠形式",
      dataIndex: "promoStyleName",
      width: 120,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: "最小值",
      dataIndex: "minLimit",
      width: 120,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: "最大值",
      dataIndex: "maxLimit",
      width: 120,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: "备注",
      dataIndex: "remark",
      width: 120,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: "发包规则",
      dataIndex: "sendPackageRule",
      width: 120,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: "限制类型",
      dataIndex: "limitTypeName",
      width: 120,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '活动成本归属',
      dataIndex: 'costBelongName',
      width: 120,
    },
    {
      title: '是否必须',
      dataIndex: 'required',
      width: 90,
      render: (value) => (
        <span>{ value ? '是' : '否' }</span>
      ),
    },
    {
      title: "操作",
      width: 210,
      fixed: "right",
      render: "editCell"
    }
  ],
  search: [
    {
     name: "keyword",
     label: "编码",
     placeholder: "SKU_ID/SPU_ID/物料SPU编码/物料SKU编码",
     width:400,
   },
    {
      name: "keyname",
      label: "SKU名称",
      width:280,
    },
  ],
  footer: [
    { label: '下载模板', render: 'exportRender' },
    { label: '导入产品', render: 'importRender' },
    {
      label: "新建",
      type: "primary",
      events: ["onClick:onAdd"]
    },
  ]
}
